import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Controller, useFormContext } from 'react-hook-form';
import FormControlledDropdown from '../../../components/inputs/FormInputs/FormControlledDropdown';
import { RegisterFormFields } from './RegisterForm';
import {
  EditOption,
  EditValues,
} from '../../../Interfaces/admin/Role.interfaces';

type EditReportDialogProps = {
  show: boolean;
  hide: () => void;
  header: string;
  report: string;
  index: number;
  showNotification: boolean;
  showApproval: boolean;
  defaultEdit?: EditValues;
  editOption?: EditOption[];
};

const EditReportDialog = ({
  show,
  hide,
  header,
  report,
  index,
  showNotification,
  defaultEdit,
  editOption,
  showApproval,
}: EditReportDialogProps) => {
  const { control, setValue } = useFormContext<RegisterFormFields>();

  return (
    <Dialog
      header={`Edit ${header}`}
      visible={show}
      onHide={() => {
        hide();
      }}
      className="w-fit capitalize"
      contentClassName="flex flex-column gap-2"
    >
      {showNotification && (
        <div className="flex gap-2 align-items-center">
          <Controller
            name={`access.${index}.shouldNotify`}
            control={control}
            defaultValue={undefined}
            render={({ field }) => (
              <Checkbox
                inputId={report + '_sn'}
                checked={field.value}
                inputRef={field.ref}
                onChange={(e) => {
                  field.onChange(e.checked);

                  if (e.checked) {
                    setValue(`access.${index}.selected`, true);
                  }
                }}
              />
            )}
          />
          <label
            htmlFor={report + '_sn'}
            className="ml-1 mr-3 blackText text-standard"
          >
            Receive Notification
          </label>
        </div>
      )}
      {editOption && (
        <div className="flex gap-2 align-items-center">
          <label
            htmlFor={`access.${index}.editable`}
            className="text-standard block blackText"
          >
            Edit
          </label>
          <FormControlledDropdown
            defaultValue={defaultEdit ? `${defaultEdit}` : undefined}
            formID={`access.${index}.editable`}
            options={editOption}
            labelField="label"
            valueField="value"
            placeholder="Select option"
            clearable={false}
            additionalChange={() => {
              setValue(`access.${index}.selected`, true);
            }}
          />
        </div>
      )}
      {showApproval && (
        <div className="flex gap-2 align-items-center">
          <Controller
            name={`access.${index}.shouldApprove`}
            control={control}
            defaultValue={undefined}
            render={({ field }) => (
              <Checkbox
                inputId={report + '_sa'}
                checked={field.value}
                inputRef={field.ref}
                onChange={(e) => {
                  field.onChange(e.checked);

                  if (e.checked) {
                    setValue(`access.${index}.selected`, true);
                  }
                }}
              />
            )}
          />
          <label
            htmlFor={report + '_sa'}
            className="ml-1 mr-3 blackText text-standard"
          >
            Approve content
          </label>
        </div>
      )}
    </Dialog>
  );
};

export default EditReportDialog;
